import React, { Component } from 'react';
import Filter from './Filter';

class Filters extends Component {

	constructor(props) {
		super(props);

		this.handleFilterChange = this.handleFilterChange.bind(this);
		this.handleResetFilters = this.handleResetFilters.bind(this);
	}

	handleFilterChange(fld) {
		this.props.onFilterChange(fld);
	}

	handleResetFilters(e) {
		e.preventDefault();
		this.props.onResetFilters();
	}

	render() {
		var html  = '';
		var reset = '';

		if (this.props.categories === null || this.props.categories.selected !== 0)
		{
			html = <div className="grid grid--filters">

				{this.props.items.map((filter, index) =>
				<div className="grid__item" key={ index }>

					<Filter data={ filter } onFilterChange={ this.handleFilterChange } />

				</div>
				)}

			</div>;

			reset = <div className="product-filters__reset">

				<a onClick={ this.handleResetFilters }>Reset Filters</a>

			</div>;
		}

		return (
			<div className="product-filters">

				<div className="product-filters__filters">

					{html}

				</div>

				{reset}

			</div>
		);
	}
}

export default Filters;
